var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-container',{attrs:{"fluid":""}},[_c('ControlHeader',{attrs:{"pageData":_vm.pageData,"showCreate":false,"valid":true}}),_c('ShiftsContent',{attrs:{"report":_vm.report,"print-static-data":_vm.printStaticData,"page-data":_vm.pageData,"print-template-type":_vm.printTemplateType}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }